<template>
    <div class="vld-parent">
        <loading :active.sync="isLoading"></loading>
    </div>
</template>

<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    
    export default {
        data() {
            return {
                isLoading: false,
                isLoaded: false
            }
        },
        components: {
            Loading
        },
        created() {
          this.doAjax();
        },
        methods: {
            doAjax() {
                this.isLoading = true;
                setTimeout(() => {
                  this.isLoading = false
                },50)
            },
        }
    }
</script>